import { takeLatest, put, call } from 'redux-saga/effects';
import * as CorporateActions from './action';
import * as ProductActions from './action';
import * as ReportActions from './action';
import * as CaseActions from './action';
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import { CORE_API } from '../../../config';

export function* fetchCorporateData(action) {
    // Matches your Java API: /corporate/autocomplete/name/{searchText}
    let requestUrl = `${CORE_API}/corporate/autocomplete/name/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CorporateActions.fetchCorporateAutocompleteSuccess(result.data));
    } catch (err) {
        yield put(CorporateActions.fetchCorporateAutocompleteFailure(err.response));
    }
}

export function* fetchCorporateAutocompleteSaga() {
    yield takeLatest(CorporateActions.FETCH_CORPORATE_AUTOCOMPLETE, fetchCorporateData);
}

export function* productSaga(action) {
    const requestUrl = `${CORE_API}/product/list/corporates`;

    try {
        const { corporateId } = action.payload;

        if (!corporateId) return;

        // Wrap the single string parameter inside an array
        const requestBody = [ corporateId ];

        console.log("Sending payload to backend:", requestBody);

        // FIX: Change 'body: JSON.stringify(requestBody)' to 'data: requestBody'
        const result = yield call(request, requestUrl, {
            method: 'POST',
            headers: {
                ...HTTP_HEADERS,
                'Content-Type': 'application/json' 
            },
            data: requestBody 
        });

        yield put(ProductActions.fetchProductsByCorporateSuccess(result.data));

    } catch (error) {
        console.error("Failed executing mass product sync:", error);
        yield put(ProductActions.fetchProductsByCorporateFailure(error));
    }
}

export function* productByCorporateWatcher() {
    yield takeLatest(ProductActions.FETCH_PRODUCTS_BY_CORPORATE, productSaga);
}


export function* downloadBulkReportExcelSaga(action) {
    const requestUrl = `${CORE_API}/bulkcase/bulk-update-download`;

    try {
        console.log("Initiating bulk excel download with payload:", action.payload);

        const response = yield call(request, requestUrl, {
            method: 'POST',
            headers: {
                ...HTTP_HEADERS,
                'Content-Type': 'application/json'
            },
            data: action.payload,
            responseType: 'blob', // Required if your httpHelper uses Axios
            props: { responseType: 'blob' } // Fallback wrapper variation if httpHelper uses custom config handling
        });

        const rawBlob = response.data ? response.data : response; 
        
        const blob = new Blob([rawBlob], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // 2. Generate a temporary download link in the browser DOM
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        
        const fileName = `Bulk_Report_Updation_${Date.now()}.xlsx`;
        link.setAttribute('download', fileName);
        
        document.body.appendChild(link);
        link.click();
        
        if (link.parentNode) {
            link.parentNode.removeChild(link);
        }
        window.URL.revokeObjectURL(downloadUrl);

        // 4. Notify Redux of success state
        yield put(ReportActions.downloadBulkReportExcelSuccess());

    } catch (error) {
       let handledError = "Failed to download spreadsheet";
        if (error.response && error.response.data instanceof Blob) {
            const blobText = yield call([error.response.data, error.response.data.text]);
            try {
                const parsed = JSON.parse(blobText);
                handledError = parsed.message || handledError;
            } catch(e) {}
        } else {
            handledError = error.message || error;
        }

        yield put(ReportActions.downloadBulkReportExcelFailure(handledError));
    }
}

// Watcher Saga
export function* downloadBulkReportExcelWatcher() {
    yield takeLatest(ReportActions.DOWNLOAD_BULK_REPORT_EXCEL, downloadBulkReportExcelSaga);
}

export function* bulkCaseUpdationSaga(action) {

    const requestUrl = `${CORE_API}/bulkcase/bulk-updation-upload`;

    try {
        const formDataPayload = action.payload.file ? action.payload.file : action.payload;
        const result = yield call(request, requestUrl, {
            method: 'POST',
            headers: {
                ...HTTP_HEADERS,
                'Content-Type': 'multipart/form-data'
            },
            data: formDataPayload
        });

        const successMessage = result?.message || "Bulk case upload processed successfully.";
        yield put(CaseActions.updateBulkCasesSuccess(successMessage));

    } catch (error) {

    let msg = "Bulk case upload failed.";

    if (error?.response?.data) {

        msg = error.response.data.message || error.response.data.error || JSON.stringify(error.response.data);
    } 
    else if (error?.message) {
        msg = error.message;
    }
        yield put(CaseActions.updateBulkCasesFailure(msg));
    }
}

export function* bulkCaseUpdationWatcher() {
    yield takeLatest(CaseActions.UPDATE_BULK_CASES, bulkCaseUpdationSaga);
}

export function* fetchBulkCaseUpdationListSaga(action) {
    const { pageNumber, pageSize } = action.payload;
    const requestUrl = `${CORE_API}/bulkcase/updation/fetch/${pageNumber}/${pageSize}`;

    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        const data = result.data || {};
        yield put(CaseActions.fetchBulkCaseUpdationListSuccess({
            recordList: data.content || [],
            numberOfPages: data.totalPages || 0,
            totalElements: data.totalElements,
            page: data.page,
            size: data.size,
        }));
    } catch (error) {
        yield put(CaseActions.fetchBulkCaseUpdationListFailure(error?.response || error));
    }
}

export function* fetchBulkCaseUpdationListWatcher() {
    yield takeLatest(CaseActions.FETCH_BULK_CASE_UPDATION_LIST, fetchBulkCaseUpdationListSaga);
}

export function* downloadBulkCaseUpdationFileSaga(action) {
    const requestUrl = `${CORE_API}/bulkcase/s3/${action.payload}`;

    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        const presignedUrl = result.data?.url || result.data;
        yield put(CaseActions.downloadBulkCaseUpdationFileSuccess(presignedUrl));
    } catch (error) {
        yield put(CaseActions.downloadBulkCaseUpdationFileFailure(error?.response || error));
    }
}

export function* downloadBulkCaseUpdationFileWatcher() {
    yield takeLatest(CaseActions.DOWNLOAD_BULK_CASE_UPDATION_FILE, downloadBulkCaseUpdationFileSaga);
}